import React from 'react'

const Singapore = () => {
  return (
    <div>Singapore</div>
  )
}

export default Singapore